import React from "react";
import "./contacts.scss";
import StarIcon from "@mui/icons-material/Star";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ForumIcon from "@mui/icons-material/Forum";
import ShareIcon from "@mui/icons-material/Share";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import EditIcon from "@mui/icons-material/Edit";
import { Avatar } from "@mui/material";

const Card = ({
  edit,
  name,
  address,
  feedback,
  status,
  img,
  users,
  setusers,
  index,
  setedit,
  preview,
  setpreview,
  ondel,
}) => {
  return (
    <div className="card p-3" style={{ width: "500px", padding: "2rem" }}>
      <div className="d-flex mb-0">
        <div className="d-flex flex-column justify-content-center user-profile w-100">
          <div className="row">
            <div className="col-12 col-md-4 mb-0 img-center d-flex flex-column justify-content-center justify-content-md-start">
              <div>
                <div className="icons-container stars d-flex flex-row justify-content-end">
                  <Tooltip title="Star">
                    <IconButton aria-label="Star">
                      <StarIcon className="col-orange" />
                    </IconButton>
                  </Tooltip>
                </div>
                <Avatar
                  variant="circular"
                  style={{
                    width: "56px",
                    height: "56px",
                    margin: "auto",
                  }}
                  src={img}
                  alt={name}
                />
              </div>
              {/* Card title */}
              <div className="doc-card-title pt-2 text-center">
                <h4 style={{ color: "#00bdf2", textTransform: "capitalize" }}>
                  {name}
                </h4>
              </div>
            </div>
            {/* Row One Card Four */}
            <div className="col-md-8 mb-0">
              {/* Card description */}
              <div className="description">
                <div>
                  <i className="fas fa-map-marker-alt pt-3 psr-3"></i>{" "}
                  {address.toUpperCase()}
                </div>
                <div>
                  <i className="far fa-comment-dots pt-3 psr-3"></i>
                  {feedback}
                </div>
                <div>
                  <i className="far fa-clock pt-3 psr-3 pb-3"></i>{" "}
                  {status?.toUpperCase()}
                </div>
              </div>
              {/* Card Button Icons section */}
              <div>
                <div className="contact-icons-container">
                  {/* View Profile Tooltip */}
                  <Tooltip
                    title="View Profile of Contact"
                    arrow
                    onClick={() => {
                      console.log(index, "índex");
                      let { ispreview, contactIndex, contact } = preview;
                      for (let i = 0; i < users.length; i++) {
                        if (i === index) {
                          ispreview = true;
                          contactIndex = i;
                          contact = users[i];
                          const data = { ispreview, contactIndex, contact };
                          setpreview(data);
                        }
                      }
                    }}
                  >
                    <IconButton className="icon-btn-margin" aria-label="Make visible">
                      <VisibilityIcon className="visibility-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* Delete Tooltip */}
                  <Tooltip
                    title="Delete contact"
                    arrow
                    onClick={() => {
                      const remaining = [];
                      for (let i = 0; i < users.length; i++) {
                        if (i !== index) {
                          remaining.push(users[i]);
                        }
                      }
                      setusers(remaining);
                      ondel();
                    }}
                  >
                    <IconButton className="icon-btn-margin" aria-label="Delete">
                      <DeleteIcon className="delete-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* Chat Tooltip */}
                  <Tooltip title="Chat contact" arrow>
                    <IconButton className="icon-btn-margin">
                      <ForumIcon className="forum-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* Share Tooltip */}
                  <Tooltip title="Share contact" arrow>
                    <IconButton className="icon-btn-margin">
                      <ShareIcon className="share-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* PDF Tooltip */}
                  <Tooltip title="Pdf of contact" arrow>
                    <IconButton className="icon-btn-margin">
                      <PictureAsPdfIcon className="picture-as-pdf-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* Edit Tooltip */}
                  <Tooltip
                    title="Edit contact"
                    arrow
                    onClick={() => {
                      console.log(index, "índex");
                      let { isedit, contactIndex, contact } = edit;
                      for (let i = 0; i < users.length; i++) {
                        if (i === index) {
                          isedit = true;
                          contactIndex = i;
                          contact = users[i];
                          const data = { isedit, contactIndex, contact };
                          setedit(data);
                        }
                      }
                    }}
                  >
                    <IconButton className="icon-btn-margin">
                      <EditIcon className="print-icon" />
                    </IconButton>
                  </Tooltip>
                  {/* Video Call Tooltip */}
                  <Tooltip title="Video Call" arrow>
                    <IconButton className="icon-btn-margin">
                      <VoiceChatIcon className="voice-icon" />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
